
import { State, Mutation } from 'vuex-class';
import { DeviceInfo } from '@/types/device-info';
import { Component, Vue, Prop } from 'vue-property-decorator';
import DeviceCard from '@/components/devices/DeviceCard.vue';
import { mutations } from '@/store/types';
import { SetDeviceMutationType } from '@/types/store/mutations';

@Component({
    components: {
        DeviceCard,
    },
})
export default class AirboltsCarousel extends Vue {
    @State('devices')
    devices!: DeviceInfo[];

    @State('device')
    current!: DeviceInfo;

    @Mutation(mutations.SET_CURRENT_DEVICE)
    setCurrentDevice!: SetDeviceMutationType;

    handleDeviceClick(device: DeviceInfo) {
        if (device._id != this.current._id) {
            const redirectURL = this.$route;
            if (redirectURL?.name === 'group-device') {
                this.setCurrentDevice({ device });
            } else {
                this.$router.push({ name: 'device-overview', params: { deviceUUID: device.deviceUUID as string } });
            }
        }
    }

    protected swiperOption() {
        return {
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                },
                730: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1000: {
                    slidesPerView: 3,
                },
                1400: {
                    slidesPerView: 3,
                },
                1600: {
                    slidesPerView: 3,
                },
                2100: {
                    slidesPerView: 3,
                },
            },
            spaceBetween: 20,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // slidesPerView: 'auto',
            // loop: true,
            centerInsufficientSlides: true,
            // centeredSlides: true
            allowTouchMove: false,
        };
    }

    mounted() {
        this.handleSAwiperAnimation();

        // Handle slider btn click
        let el = document.querySelectorAll(
            '.AirboltsCarousel .swiper-button-next, .AirboltsCarousel .swiper-button-prev',
        );
        for (var i = 0; i < el.length; i++) {
            el[i].addEventListener('click', () => {
                setTimeout(() => {
                    this.handleSAwiperAnimation();
                }, 200);
            });
        }
    }
    updated() {
        this.handleSAwiperAnimation();
    }

    handleSAwiperAnimation() {
        const nextBtn = document.getElementById('swiper-button-next') as HTMLElement;
        const prevBtn = document.getElementById('swiper-button-prev') as HTMLElement;
        let isNext = nextBtn.classList.contains('swiper-button-disabled') ? false : true;
        let isPrev = prevBtn.classList.contains('swiper-button-disabled') ? false : true;

        let right = document.getElementById('position-right') as HTMLElement;
        let right1 = document.getElementById('position-right-1') as HTMLElement;
        let left = document.getElementById('position-left') as HTMLElement;
        let left1 = document.getElementById('position-left-1') as HTMLElement;

        right.style.display = isNext ? 'block' : 'none';
        right1.style.display = isNext ? 'block' : 'none';
        left.style.display = isPrev ? 'block' : 'none';
        left1.style.display = isPrev ? 'block' : 'none';
    }
}
